import { PreviewPayId } from './PreviewPayId'

import { PaymentMethods, useCheckoutPolling } from 'mmfintech-checkout-commons'

import { tr } from 'mmfintech-commons'
import { InstructionsContainer } from './PreviewInstructions.styled'

import type { BaseInstructionsResult, FlutterwaveMobileAppInstructionsResult } from 'mmfintech-checkout-commons/types'

interface PreviewInstructionsProps {
  result: BaseInstructionsResult
  sessionId: string
}

export const PreviewInstructions = ({ result, sessionId }: PreviewInstructionsProps) => {
  const { paymentMethod } = result || {}

  const { startPolling } = useCheckoutPolling({
    sessionId,
    pollingInterval: 5000,
    maxPollCount: 60
  })

  if (paymentMethod === PaymentMethods.PAY_ID) {
    startPolling()
    return <PreviewPayId result={result} />
  }

  if (paymentMethod === PaymentMethods.M_PESA) {
    startPolling()
    const { phoneNumber } = result as FlutterwaveMobileAppInstructionsResult
    return (
      <InstructionsContainer>
        {tr(
          'CHECKOUT.INSTRUCTIONS.MPESA',
          'You will receive a prompt on mobile number {{phone_number}} to enter your MPESA service PIN to authorize your payment request.',
          { phone_number: phoneNumber }
        )}
      </InstructionsContainer>
    )
  }

  if (paymentMethod === PaymentMethods.MOBILE_MONEY) {
    startPolling()
    const { phoneNumber } = result as FlutterwaveMobileAppInstructionsResult
    return (
      <InstructionsContainer>
        {tr(
          'CHECKOUT.INSTRUCTIONS.MOBILE_MONEY',
          'You will receive a prompt on mobile number {{phone_number}} to enter your Mobile Money service PIN to authorize your payment request.',
          { phone_number: phoneNumber }
        )}
      </InstructionsContainer>
    )
  }

  return null
}
